import { FormattedMessage } from 'react-intl';
import { ListItemIcon, ListItemText, MenuItem, MenuItemProps } from '@mui/material';
import { ReactElement } from 'react';
import { TruckIcon } from '@synergy/theme-next';
import { useIsMobile } from '@synergy/components-next';
import { useNavigate } from 'react-router';

import { CategoryTreeDrawer } from '../drawer/category-tree-drawer';
import { CategoryTreePopup } from '../popup/category-tree-popup';
import { ROUTES } from '../../../../utils/routes';

export interface CategoryTreeMenuProps {
    anchorEl?: HTMLElement | null;
    isOpen?: boolean;
    children?: ReactElement<MenuItemProps> | ReactElement<MenuItemProps>[];
    onSelect: (id: number) => void;
    onClose: () => void;
}

export const CategoryTreeMenu = (props: CategoryTreeMenuProps): ReactElement => {
    const isMobile = useIsMobile();
    const navigate = useNavigate();

    const AdditionalMenuItems = [
        <MenuItem
            key="0"
            onClick={e => {
                e.stopPropagation();
                props.onClose();
                navigate(ROUTES.supplierDirectory.base);
            }}
        >
            <ListItemIcon>
                <TruckIcon />
            </ListItemIcon>
            <ListItemText>
                <FormattedMessage id="app.supplierDirectory.title" />
            </ListItemText>
        </MenuItem>,
    ];

    return isMobile ? (
        <CategoryTreeDrawer {...props}>{AdditionalMenuItems}</CategoryTreeDrawer>
    ) : (
        <CategoryTreePopup {...props}>{AdditionalMenuItems}</CategoryTreePopup>
    );
};
